import React from 'react'
import {Container, Content} from './styled';
import Button from '../../components/Button';
import Cookies from 'universal-cookie';
import {Link} from 'react-router-dom';
import { Slide } from '@material-ui/core';

const CookiesBar: React.FC = () => {
    const cookies = new Cookies();

    // eslint-disable-next-line
    const [accept, setAccept] = React.useState(false);

    function Accept() {
        cookies.set('cookies-accept', 'yes', {path: '/'});
        setAccept(true);
    }

    return (
        <>            
            <Slide direction="up" in={!cookies.get('cookies-accept')} mountOnEnter unmountOnExit>
                <Container>
                    <Content>
                        <Button type="submit" onClick={Accept}>Entendi</Button>
                        <p>Utilizamos cookies para melhorar sua experiência em nosso site e, ao continuar navegando, você concorda com estas condições. 
                            <Link to={`${process.env.PUBLIC_URL}/politica-de-cookies`}
                                title="Política de Cookies">Política de Cookies</Link>
                        </p>
                    </Content>
                </Container>
            </Slide>
        </>
    )
}

export default CookiesBar;